import { ref } from 'vue'
import { defineStore } from 'pinia'
import {useTariffSettingsHintStore} from './tariffSettingsHintStore'

export const useUserStore = defineStore('user', () => {
  const userInfo = ref(null)
  const isAuth = ref(false)
  const userProfile = ref(null)
  const isInitialized = ref(false)
  const { $api } = useNuxtApp()

  const getUserData = async () => {
    try {
      const data = await $api('/proxy/profile-api.bpmn/api/v1/profile/user', {})
      userProfile.value = data
      isAuth.value = true

      userInfo.value = {
        id: data.id,
        email: data.email,
        phone: data.phone?.trim(),
        lastName: data.lastname?.trim(),
        firstName: data.firstname?.trim(),
        lang: data.lang,
        avatar: null
      }
      fetchAvatar()
    } catch (e) {
      isAuth.value = false
      userInfo.value = null
      userProfile.value = null
    } finally {
      isInitialized.value = true
    }
  }

  const fetchAvatar = async () => {
    if (process.client && userInfo.value && !userInfo.value.avatar) {
      try {
        const avatarBlob = await $api('/proxy/profile-api.bpmn/api/v1/profile/avatar', { responseType: 'blob' });
        if (avatarBlob && avatarBlob.size > 0) {
          userInfo.value.avatar = URL.createObjectURL(avatarBlob);
        }
      } catch (e) {
        console.error("Avatar load error", e);
      }
    }
  };

  const expireSession = () => {
    isAuth.value = false
    isInitialized.value = true
    if (userInfo.value?.avatar) URL.revokeObjectURL(userInfo.value.avatar)
    userInfo.value = null
    userProfile.value = null
  }

  const logout = () => {
    const cookieStore = useCookieStore();
    const tapStore = useTapStore()
    cookieStore.updateToken(null)
    tapStore.resetTapState()

    isAuth.value = false
    if (userInfo.value?.avatar) {
      URL.revokeObjectURL(userInfo.value.avatar);
    }
    userInfo.value = null
    userProfile.value = null

    const hintStore = useHintStore()
    hintStore.clearHints()
    useTariffSettingsHintStore().reset()

    return $api('/proxy/account-recovery-api.bpmn/auth/logout').catch(() => {})
  }

  const updateToken = async (t) => {
    const tapStore = useTapStore()
    const hintStore = useHintStore()

    tapStore.resetTapState()
    hintStore.clearHints()
    useTariffSettingsHintStore().reset()
    isInitialized.value = false
    await getUserData()
  }

  return {
    userInfo,
    isAuth,
    updateToken,
    isInitialized,
    getUserData,
    expireSession,
    logout,
    fetchAvatar
  }
})
